// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"831799c6","453":"eb1162dd","743":"831799c6","752":"501449e2","948":"262fe95c"}[chunkId] + ".chunk.js";
};